<template>
  <appointment-new-space-coordination
    :get-appointment-info="getAppointmentInfo"
    :get-contact-information="getContactInformation"
    :get-phone-providers="getPhoneProviders"
    :get-relationships="getRelationships"
    :navigate-to="navigateTo"
    :save-space-coordination="saveSpaceCoordination"
  />
</template>

<script>
import { AppointmentNewSpaceCoordination } from 'appointment-management';
import { getAppointmentInfo as _getAppointmentInfo } from '@/modules/provider/api';
import {
  getRelationships as _getRelationships,
  getPhoneProviders as _getPhoneProviders,
  getContactInformation as _getContactInformation,
} from '@/modules/shared/provider.api';

import { saveSpaceCoordination as _saveSpaceCoordination } from '@/modules/appointmentManagement/api';

export default {
  name: 'AppointmentNewSpaceCoordinationWrapper',
  components: {
    AppointmentNewSpaceCoordination,
  },
  data() {
    return {
      navigateTo: '/provider/appointmentManagement',
    };
  },
  methods: {
    async saveSpaceCoordination(data) {
      await _saveSpaceCoordination(data);
    },
    async getAppointmentInfo(id) {
      return _getAppointmentInfo(id);
    },
    async getRelationships() {
      return _getRelationships();
    },
    async getPhoneProviders() {
      return _getPhoneProviders();
    },
    async getContactInformation(studentId) {
      return _getContactInformation(studentId);
    },
  },
};
</script>
